import React, { useEffect, useState } from 'react';
import MainLogo from './components/Header/main_logo.svg';
import './styles/Examination.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getApiV1Url } from './config/api';
import AutocompleteInput from './components/Filters/AutocompleteInput';

const OrgForm = () => {
  const [companies, setCompanies] = useState<{ inn: string; name: string }[]>([]);
  const [inn, setInn] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const access = localStorage.getItem('access');
    axios.get(getApiV1Url('COMPANIES'), {
      headers: access ? { Authorization: `Bearer ${access}` } : {}
    })
      .then(res => {
        if (Array.isArray(res.data)) {
          setCompanies(res.data.map((c: any) => ({ inn: c.inn, name: c.name })));
        }
      });
  }, []);

  // Подставка наименования
  const handleInnChange = (e: React.ChangeEvent<HTMLInputElement> | string) => {
    const value = typeof e === 'string' ? e : e.target.value;
    setInn(value);
    const found = companies.find(c => c.inn === value);
    if (found) setName(found.name);
  };

  // Подставка ИНН
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement> | string) => {
    const value = typeof e === 'string' ? e : e.target.value;
    setName(value);
    const found = companies.find(c => c.name === value);
    if (found) setInn(found.inn);
  };

  const handleBack = () => {
    navigate('/');
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (inn) params.append('inn', inn);
    if (name) params.append('name', name);
    navigate(`/examination?${params.toString()}`);
  };

  return (
    <div className="org-form__container">
      <div className="org-form__logo-block">
        <img
          src={MainLogo}
          alt="АПТС"
          className="org-form__logo"
        />
      </div>
      <div className="org-form__title">
        Комплексная проверка организации
      </div>
      <form onSubmit={handleSearch} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <AutocompleteInput
          id="inn"
          value={inn}
          options={companies.map(c => c.inn)}
          placeholder="Поиск по ИНН"
          onChange={(val) => handleInnChange(val)}
          onSelectOption={(val) => {
            setInn(val);
            const found = companies.find(c => c.inn === val);
            if (found) setName(found.name);
          }}
          inputClassName="org-form__input"
          wrapperClassName="org-form__input--inn"
        />
        <AutocompleteInput
          id="name"
          value={name}
          options={companies.map(c => c.name)}
          placeholder="Поиск по наименованию организации"
          onChange={(val) => handleNameChange(val)}
          onSelectOption={(val) => {
            setName(val);
            const found = companies.find(c => c.name === val);
            if (found) setInn(found.inn);
          }}
          inputClassName="org-form__input"
          wrapperClassName="org-form__input--name"
        />
        <button type="submit" className="org-form__button org-form__button--search">
          ПОИСК
        </button>
        <button type="button" className="org-form__button org-form__button--back" onClick={handleBack}>
          Вернуться на главную
        </button>
      </form>
    </div>
  );
};

export default OrgForm;
